import { ProPageStrings } from 'react_components/mixins/shared/string_constants_mixin';
import isEmail from 'validator/lib/isEmail';

// Teasing this apart from a big function to individual validators similar to https://react-hook-form.com/get-started#Applyvalidation
const validateUserForm = (name, value, errors) => {
  const { email, password, firstName, lastName } = ProPageStrings.loginForm;
  switch (name) {
    case 'userRegEmail':
      if (!isEmail(value)) {
        errors[name] = email.validation.generic;
      } else {
        delete errors[name];
      }
      break;
    case 'userRegPassword':
    case 'password':
    case 'confirmPassword':
      if (value.length < 6) {
        errors[name] = password.validation.generic;
      } else {
        delete errors[name];
      }
      break;
    case 'userRegFirstName':
      if (value.length < 1) {
        errors[name] = firstName.validation.generic;
      } else {
        delete errors[name];
      }
      break;
    case 'userRegLastName':
      if (value.length < 1) {
        errors[name] = lastName.validation.generic;
      } else {
        delete errors[name];
      }
      break;
    default:
      break;
  }

  return { errors };
};

const hasErrors = errors => {
  for (const name in errors) {
    if (errors[name].length > 0) {
      return true;
    }
  }
  return false;
};

export { validateUserForm, hasErrors };
